import React from 'react'
import { ColumnStartOrder, ColumnName, ColumnNoc, } from "components/common/TableColumns"
import Label from "components/general/Label"
import useViewport from 'components/general/useViewPort';
export function TableColumnsStartList(isMobile) {

    return (
        [
            ColumnStartOrder({ disableSort: true, label: 'StartNum' }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            {
                Header: <Label data={'HeaderHandicapTime'} />,
                accessor: (props) => (
                    props.eventUnitEntries
                        ? props.eventUnitEntries.find(row => row.eue_code === 'HCP_TIME')?.eue_value
                        : ''
                ),
                className: "text-end",
                headerClassName: `text-end ${isMobile ? 'w-30' : 'w-15'}`,
                disableSortBy: true,
                id: 'HandicapTime',
                Cell: (props) => {
                    let eue = props.cell.row.original?.eventUnitEntries;
                    let handicap = eue?.find(row => row.eue_code === 'HCP_TIME')?.eue_value
                    let wave = eue?.find(row => row.eue_code === 'WAVE')?.eue_value

                    let waveComp
                    if (wave) {
                        waveComp = Label({ data: 'HeaderWave' }) + ": " + wave;
                    }

                    return (
                        <div className='d-flex'>
                            <div className='w-40 text-start'>{waveComp}</div>
                            <div className='w-60 '>{handicap}</div>
                        </div>
                    )

                }

            }

        ])
}


export default TableColumnsStartList




